<template>
    <div class="container-fluid bg-grey">
        <div class="row">
            <div class="container m-y-xl">
                <div class="title text-center">
                    <h1 class="text-cgrey ">Retrieve password</h1>
                </div>
                <h4 class="text-cgrey text-center">
                    Enter in the email address associated with the account to receive instructions on how to reset your password.
                </h4>
                <div class="text-center bg-white fine-border border-green m-t p-t-md p-b-lg">
                    <div class="w-md m-auto">
                        <div class="form m-y">
                            <template v-if="!successMessage">
                                <div class="form-group field">
                                    <input
                                        @keyup.enter="validateForm"
                                        ref="email"
                                        v-model.trim="email"
                                        v-validate="'required|email'"
                                        data-vv-validate-on="change"
                                        data-vv-as="email"
                                        name="forgot-password-email"
                                        placeholder="Email"
                                        type="email"
                                        class="form-control">
                                    <span v-show="errors.has('forgot-password-email')" class="help text-danger">
                                        {{ errors.first('forgot-password-email') }}
                                    </span>
                                </div>
                                <button
                                    @click="validateForm"
                                    class="btn btn-round btn-block btn-green"
                                    :class="{'disable-element': isSendingEmail }"
                                    :disabled="isSendingEmail"
                                    type="submit">
                                    {{ isSendingEmail ? "SUBMITING..." : "SUBMIT" }}
                                </button>
                            </template>
                            <h4 v-else class="text-cgrey text-center">
                                {{ successMessage }}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Validator } from 'vee-validate';

export default {
    name: "ForgotPassword",
    data() {
        return {
            successMessage: '',
            isSendingEmail: false,
            password: "",
            email: "",
        }
    },
    created() {
        this.setupValidationErrorMessages();
    },
    methods: {
        async validateForm() {
            const isValid = await this.$validator.validateAll();
            if (!isValid) {
                return;
            }

            this.submitForm();
        },
        submitForm() {
            this.isSendingEmail = true;

            const formData = new FormData();
            formData.append("email", this.email);

            axios.post("/auth/reset", formData).then(response => {
                this.successMessage = response.data.message;
            }).catch(error => {
                toastr.error(error.response.data.status.message);
                $(this.$refs.email).focus();
            }).finally(() => this.isSendingEmail = false);
        },
        setupValidationErrorMessages() {
            const dictionary = {
                en: {
                    custom: {
                        "forgot-password-email": {
                            required: 'You did not enter in a valid email address. Please try again.'
                        }
                    }
                }
            };

            Validator.localize(dictionary);
        }
    }
}
</script>

<style scoped>
    .btn:focus {
        color: white;
    }
    .btn:hover {
        color: var(--purple);
    }

    .vv-error-message {
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        color: red;
    }
</style>